<div class="action">
    <ng-container *ngIf="reportName !== 'Brandstudio_Replenishment'; else brandStudioTemplate">
        <input [(ngModel)]="data.userWorkOrders" placeholder="Enter work orders"
            *ngIf="reportName !== 'Brandstudio_Replenishment_SKU'" />
        <input [(ngModel)]="workOrderData[data.sku]" (ngModelChange)="updateWorkOrderData(data, $event)"
            placeholder="Enter work orders" *ngIf="reportName === 'Brandstudio_Replenishment_SKU'" />
        <mat-icon matTooltip="Create Work Order" *ngIf="reportName !== 'Brandstudio_Replenishment_SKU'"
            [ngClass]="{'green-color': verifyToEnableIconColor.id==(data.materialCode||data.sku)}"
            class="confirm-work-orders" mat-button color="primary"
            (click)="handleConfirmation(data)">check_circle</mat-icon>
        <mat-icon class="confirm-work-orders" matTooltip="Bill of materials" mat-button color="secondary"
            (click)="showBOMStatus(data)">inventory</mat-icon>
    </ng-container>
    <ng-template #brandStudioTemplate>
        <mat-icon matTooltip="Create Work Order" class="confirm-work-orders" mat-button color="primary"
            (click)="showCreateWODialog(data)">assignment_add</mat-icon>
    </ng-template>
</div>

<ejs-dialog class="modal rounded" *ngIf="dialogVisible" id="dialog" #ejDialog [isModal]="true" width="500px"
  [visible]="dialogVisible">
  <button (click)="onOverlayClick()" type="button" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <ng-container *ngIf="createWorkOrdersFromUser">
    <div class="create-orders-confirm" *ngIf="reportName !== 'Brandstudio_Replenishment'">
      <h3>You are about to create a work order of qty <strong>{{createWorkOrdersFromUser.qty}}</strong>. This will cause
        <strong>'Excess' inventory of
          {{getConfigDataForSpecificRow.piCreatedToday-getConfigDataForSpecificRow.piToBeCreated+createWorkOrdersFromUser.qty}}</strong>
        in the system. Are you sure you want to continue?
      </h3>
    </div>
    <div class="create-orders-confirm" *ngIf="reportName === 'Brandstudio_Replenishment'">
      <h3>You are about to create the following work orders. This will cause
        <strong>'Excess' inventory of displayed quantities</strong>
        in the system. Are you sure you want to continue?
      </h3>
      <div class="excess-sku-container">
        <div *ngFor="let sku of excessWorkOrderKeys">
          <span><strong>{{ sku }}</strong></span> - <span class="quantity"><strong>{{
              excessWorkOrderDetails[sku] }}</strong></span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-around">
      <button type="button" style="background-color: gray; color: white;" class="btn btn-lg"
        (click)="onOverlayClick()">Cancel</button>
      <button type="button" style="background-color: #ffa000;" class="btn btn-lg"
        (click)="determineWorkOrderAction()">Confirm</button>
    </div>
  </ng-container>
</ejs-dialog>
<ejs-dialog class="modal rounded" *ngIf="bomDialogVisible" id="bom-dialog" #ejDialog [isModal]="true" width="90%"
  height="auto" [visible]="bomDialogVisible">
  <button (click)="onOverlayClick()" type="button" class="close" aria-label="Close"><span
      aria-hidden="true">&times;</span></button>
  <app-bom-availability-state [sku]="selected_bomdata.materialCode || selected_bomdata.sku"
    [location]="selected_bomdata.locationCode || selected_bomdata.location"
    displayName="Bill of Materials Availability Status"></app-bom-availability-state>
</ejs-dialog>

<ejs-dialog class="modal rounded" *ngIf="createWODialogVisible" id="sku-dialog" #ejDialog [isModal]="true" width="70%"
  height="auto" [visible]="createWODialogVisible" [header]="dialogHeaderTemplate" [content]="dialogContentTemplate">
  <ng-template #dialogHeaderTemplate>
    <div class="d-flex align-items-baseline justify-content-between">
      <h3>Create Sku Work Order</h3>
      <button (click)="onOverlayClick()" type="button" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </ng-template>
  <ng-template #dialogContentTemplate>
    <div *ngIf="skuTableFetched; else loading" class="grid-container">
      <div class="po-details">
        <div>Style Code : <strong>{{selectedDataObject.parent}}</strong></div>
        <div>
        <mat-form-field>
          <mat-label>PO Code</mat-label>
          <input matInput [formControl]="poCode" placeholder="PO Code" required>
        </mat-form-field>
        <mat-form-field>
          <mat-label> Delivery Date</mat-label>
          <input matInput [matDatepicker]="picker" [formControl]="deliveryDate" placeholder="Choose a date" required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker class="custom-datepicker"></mat-datepicker>
          <mat-error *ngIf="deliveryDate.hasError('invalidDate')">
            Invalid delivery date
          </mat-error>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="saveWorkOrders()" [disabled]="!poCode || !deliveryDate">
          Save
        </button>
      </div>
    </div>
        <app-grid-reusable-molecule [reportName]="'Brandstudio_Replenishment_SKU'" [dynamic_headers]="skuListHeaders"
        [data]="skuList" *ngIf="skuTableFetched" [workOrderData]="workOrderData"></app-grid-reusable-molecule>
    </div>
    <ng-template #loading>
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
        <p>Please wait while we create work orders...</p>
      </div>
    </ng-template>
  </ng-template>
</ejs-dialog>